<div class="page-wrapper section-hr-direct">
    <app-left-menu [showMenu]="false"></app-left-menu>
    <div id="main-container">
        <app-header [showHistoryButton]="true" [title]="title"></app-header>
        <div class="content-header"> </div>
        <div class="page-content settings">
            <div class="no-absolute m-t30">

                <form [formGroup]="providerSiteForm" (submit)="AddProviderSite(providerSiteForm.value)">
                    <div style="clear: both;"></div>
                    <div class="col-md-6">
                        <label>{{'ProviderSite.SameAsText1' |translate}} &nbsp;</label>
                        <a (click)="getBillingOrMailingAddress(1)">
                            <label style="color: blue;cursor: pointer;"> {{'ProviderSite.MailingAddress'|translate}}</label>
                        </a>
                        <label>&nbsp; {{'ProviderSite.SameAsText2' |translate}}&nbsp;</label>
                        <a (click)="getBillingOrMailingAddress(2)" style="color: blue;">
                            <label style="color: blue;cursor: pointer;">{{'ProviderSite.BillingAddress'|translate}}</label></a>
                    </div>
                    <div style="clear: both;"></div>
                    <div class="col-md-12">
                        <input type="checkbox"  formControlName="ProviderSiteStatus"> &nbsp;
                        <label>{{'ProviderSite.ProviderSiteStatus.Label'|translate}}

                        </label>

                    </div>
                   
                   
                    <div class="col-md-6">
                        <label>{{'ProviderSite.AddressLine1.Label'|translate}}<span class="required">*</span>

                        </label>


                        <input type="text" maxlength="256" formControlName="Address1">

                    </div>
                    <div class="col-md-6">
                        <label>{{'ProviderSite.AddressLine2.Label'|translate}}

                        </label>


                        <input type="text" maxlength="256" formControlName="Address2">

                    </div>



                    <div class="col-md-6">
                        <label>{{'ProviderSite.City.Label'|translate}}<span class="required">*</span>

                        </label>


                        <input type="text" maxlength="50" formControlName="City">

                    </div>
                    <div class="col-md-6">
                        <label>{{'ProviderSite.State.Label'|translate}}<span class="required">*</span>

                        </label>


                        <input type="text" maxlength="50" formControlName="State">

                    </div>

                    <div class="col-md-6">

                        <label>{{'ProviderSite.Zipcode.Label'|translate}}

                        </label>


                        <input type="text" maxlength="9" formControlName="Zipcode">
                    </div>
                    <div class="col-md-6">
                        <div class="col-sm-8" style="float:left;padding-left: 0px;">
                            <label style="display: block;">{{'ProviderSite.Contact.Label'|translate}}<span
                                    class="required">*</span>

                            </label>


                            <input type="text" mask="000-000-0000" formControlName="ContactNumber">
                        </div>
                        <div class="col-sm-4" style="float:left;">
                            <label style="display: block;">{{'ProviderSite.ContactExt.Label'|translate}}

                            </label>
                            <input type="text" maxlength="5" formControlName="ContactNumberExt">
                        </div>
                    </div>
                    <div class="col-md-6" style="clear: both;">
                        <label>{{'ProviderSite.Fax.Label'|translate}}

                        </label>


                        <input type="text" mask="000-000-0000" formControlName="Fax">

                    </div>
                    <div class="col-md-12">
                        <label>{{'ProviderSite.Description.Label'|translate}}
                            <div  class="tooltip"><i>i</i> <span class="tooltiptext" style="width:260px;" >{{'ToolTip.ProviderSiteNote'|translate}}</span></div>
                        </label>

                        <textarea type="text" appCharCount [showinitial]=true [limit]=500 maxlength="500"
                            formControlName="Description"></textarea>
                        <span id="char-count" class="char-count"></span>

                    </div>
                    <div class="col-md-12">

                        <button type="submit" class="btn btn-main"
                            [disabled]="!providerSiteForm.valid">{{'Common.Submit'|translate}}</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>